import { Stack } from "@mui/material"
import { useAPI } from "../../hooks/useAPI";

interface ImageUploaderProps {
  onImageChange: (url: string) => void;
}

export const ImageUploader = ({ onImageChange }: ImageUploaderProps) => {
  const { fetchData } = useAPI();

  const handleImageUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {

    const uploadImage = async (file: File) => {
      const formData = new FormData();
      formData.append('image', file);
   
      const {errors, data} = await fetchData('/templates/upload-image', formData, 'POST');
      
      if (errors) {
        throw new Error('Upload failed');
      }
    
      return data.url;
    };

    const file = event.target.files?.[0];
    if (file) {
      try {
        const url = await uploadImage(file);
        onImageChange(url);
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }
  };

  return (
    <Stack>
      <input type="file" accept="image/*" onChange={handleImageUpload} />
    </Stack>
  )

}